export default __webpack_public_path__ + "images/YS.93152e2.png";